import type { AxiosResponse } from 'axios';
import api from 'src/services/api';
import * as utils from './apiUtils';
import type { MasterGetAllResponse } from 'src/models/apis/master/masterResponse';

export default {
  // MasterGetAllResponseに対応するcamelCaseマッパーがuseMastersにあるので、ここではcamelCaseに変換せずにそのまま返す
  getAll(): Promise<AxiosResponse<MasterGetAllResponse>> {
    return api.get(utils.getApiUrl('/masters'));
  },
};
